import { useState, useEffect } from 'react';
import { MessageSquare, X, Send } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ChatbotWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    {
      type: 'bot',
      text: 'Hello! I\'m here to help you with Demat accounts and trading. Choose a question below or type your own!',
    },
  ]);
  const [qaData, setQaData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('all');

  useEffect(() => {
    fetchQAData();
  }, []);

  const fetchQAData = async () => {
    try {
      const response = await axios.get(`${API}/chatbot/qa`);
      setQaData(response.data);
    } catch (error) {
      console.error('Error fetching chatbot data:', error);
    }
  };

  const handleQuestionClick = (qa) => {
    setMessages((prev) => [
      ...prev,
      { type: 'user', text: qa.question },
      { type: 'bot', text: qa.answer },
    ]);
  };

  const categories = ['all', 'basics', 'account', 'broker', 'pricing', 'security', 'products', 'support'];

  const filteredQA = selectedCategory === 'all'
    ? qaData
    : qaData.filter((qa) => qa.category === selectedCategory);

  return (
    <div className="chatbot-float">
      {!isOpen ? (
        <button
          onClick={() => setIsOpen(true)}
          data-testid="chatbot-open-button"
          className="chatbot-bubble"
          aria-label="Open Chatbot"
        >
          <MessageSquare size={28} />
        </button>
      ) : (
        <div className="chatbot-window" data-testid="chatbot-window">
          <div
            className="flex items-center justify-between p-4"
            style={{ backgroundColor: '#FF5722', color: 'white' }}
          >
            <div className="flex items-center gap-2">
              <MessageSquare size={20} />
              <span className="font-semibold">Dhanamm Assistant</span>
            </div>
            <button
              onClick={() => setIsOpen(false)}
              data-testid="chatbot-close-button"
              className="hover:opacity-80"
            >
              <X size={20} />
            </button>
          </div>

          <div className="chatbot-messages scrollbar-hide">
            {messages.map((msg, idx) => (
              <div
                key={idx}
                data-testid={`chat-message-${msg.type}-${idx}`}
                className={`chat-message ${msg.type}`}
              >
                {msg.text}
              </div>
            ))}
          </div>

          <div className="border-t border-[#E2E8F0] p-4">
            <div className="mb-3">
              <p className="text-xs text-[#475569] mb-2 font-medium">Quick Questions:</p>
              <div className="flex gap-2 flex-wrap mb-3">
                {categories.map((cat) => (
                  <button
                    key={cat}
                    data-testid={`category-${cat}`}
                    onClick={() => setSelectedCategory(cat)}
                    className={`text-xs px-3 py-1 border transition-colors ${
                      selectedCategory === cat
                        ? 'bg-[#FF5722] text-white border-[#FF5722]'
                        : 'bg-white text-[#475569] border-[#E2E8F0] hover:border-[#FF5722]'
                    }`}
                  >
                    {cat.charAt(0).toUpperCase() + cat.slice(1)}
                  </button>
                ))}
              </div>
              <div className="max-h-32 overflow-y-auto scrollbar-hide space-y-2">
                {filteredQA.map((qa) => (
                  <button
                    key={qa.id}
                    data-testid={`quick-question-${qa.id}`}
                    onClick={() => handleQuestionClick(qa)}
                    className="w-full text-left text-xs p-2 bg-[#F1F5F9] hover:bg-[#E2E8F0] text-[#0A0F1A] transition-colors"
                  >
                    {qa.question}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatbotWidget;